export default __webpack_public_path__ + "static/boxo_luxe-ab7e691a0d8390ac7e6bd4ced24428d3.png";